export default interface RowCardItemState {

}

export interface RowCardItemProps {
    title: string;
    imageSource: string;
    subTitle?: string;
    config?: RowCardItemConfig;
}

interface RowCardItemConfig {
    btnColor?: string;
    titleExtraClass?: string;
    subTitleExtraClass?: string;
}

export function RowItemRestrictions(text: string, lengthOfRemove?: number) {

    let length = lengthOfRemove ?? 10;
    if (text.length < length)
        length = text.length;
    var convert = text.substring(0, length);
    var output = convert;
    if (text.length > length)
        output = output + "...";
    return output;
}